import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PackageGracePeriodBanner from '../../../packages/components/PackageGracePeriodBanner';
import PackageExpiredPage from '../../../packages/components/PackageExpiredPage';
import './package-grace-period-test.css';

const VIEWS = [
  { id: 'banner', label: 'Soft landing banner' },
  { id: 'grace-page', label: 'Grace period page' },
  { id: 'expired-page', label: 'Expired page' },
  { id: 'combined', label: 'Banner + app content' },
];

const PackageGracePeriodTestPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get('view') || 'banner';

  const setView = (nextView) => {
    setSearchParams({ view: nextView }, { replace: true });
  };

  return (
    <div className="admin-page pkgGraceTest">
      <div className="admin-page__header">
        <div>
          <h1 className="admin-page__title">Package grace period preview</h1>
          <p className="admin-page__subtitle">
            Preview subscription grace-period UI. In production, users with{' '}
            <code>grace_period</code> status keep app access and see the warning banner.
          </p>
        </div>
      </div>

      <div className="pkgGraceTest__controls" aria-label="Preview mode">
        {VIEWS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`pkgGraceTest__tab${view === item.id ? ' isActive' : ''}`}
            onClick={() => setView(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="pkgGraceTest__preview" aria-label="Grace period preview">
        {view === 'banner' && <PackageGracePeriodBanner />}

        {view === 'grace-page' && <PackageExpiredPage isGracePeriod />}

        {view === 'expired-page' && <PackageExpiredPage />}

        {view === 'combined' && (
          <>
            <PackageGracePeriodBanner />
            <div className="pkgGraceTest__mockApp">
              <h2 className="pkgGraceTest__mockTitle">App content (still accessible)</h2>
              <p className="pkgGraceTest__mockText">
                During grace period the business app remains usable. Only the banner warns the
                owner to renew before access is fully blocked.
              </p>
            </div>
          </>
        )}
      </div>

      <p className="pkgGraceTest__hint">
        Route: /tools/package-grace-period-test · Query: ?view=banner|grace-page|expired-page|combined
      </p>
    </div>
  );
};

export default PackageGracePeriodTestPage;
